import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ChanceNodeDto, TriggerDto } from "@api";
import { ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";
import { RootState } from "src/app/store";
import * as ScenarioActions from "src/app/store/scenario/actions";
import * as FromScenario from "src/app/store/scenario/selectors";

@Component({
  selector: "app-scenario",
  templateUrl: "./scenario.page.html",
  styleUrls: ["./scenario.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScenarioPage implements OnInit {
  @Input() public scenario?: ChanceNodeDto;
  @Input() public reason?: boolean;
  @Input() public parentId?: string;

  public form: FormGroup;
  public operators: string[] = [">=", ">", "==", "!=", "<=", "<"];
  public loading$: Observable<boolean> = this.store.select(FromScenario.getLoading);
  public triggers$: Observable<TriggerDto[]> = this.store.select(FromScenario.getTriggers);
  public shouldHideTriggerSelector: boolean;

  constructor(private store: Store<RootState>, private modalController: ModalController) {}

  public ngOnInit(): void {
    this.triggers$.pipe(first()).subscribe(triggers => {
      const triggerId: string = this.scenario
        ? this.scenario.triggerId
        : this.parentId
        ? triggers.find(trigger => trigger.type === TriggerDto.TypeEnum.Scenario)?.id
        : null;

      this.shouldHideTriggerSelector = !!this.parentId || triggers.find(t => t.id === triggerId)?.type === TriggerDto.TypeEnum.Scenario;

      this.form = new FormGroup({
        name: new FormControl(this.scenario?.name, [Validators.required]),
        description: new FormControl(this.scenario?.description),
        triggerId: new FormControl(triggerId, [Validators.required]),
        query: new FormControl(this.scenario?.query, [Validators.required]),
        operator: new FormControl(this.scenario?.operator, [Validators.required]),
        targetValue: new FormControl(this.scenario?.targetValue ?? 0, [Validators.required]),
        active: new FormControl(this.scenario?.active ?? true),
      });
    });
  }

  public async remove(): Promise<void> {
    this.store.dispatch(ScenarioActions.deleteChanceNodeOnScenario({ chanceNodeId: this.scenario.id }));
  }

  public dismiss(): void {
    this.modalController.dismiss();
  }

  public save(): void {
    if (this.scenario) {
      this.store.dispatch(
        ScenarioActions.updateChanceNodeOnScenario({
          chanceNodeId: this.scenario.id,
          updateChanceNodeDto: { ...this.form.value, webhookUrl: this.form.value.webhookUrl || null },
        }),
      );
    } else {
      if (this.parentId) {
        this.store.dispatch(
          ScenarioActions.createChanceNodeOnScenario({
            createChanceNodeDto: this.form.value,
            parentId: this.parentId,
            node: this.reason ? "nextIfTrueId" : "nextIfFalseId",
          }),
        );
      } else {
        this.store.dispatch(ScenarioActions.createChanceNode({ createChanceNodeDto: this.form.value }));
      }
    }
  }
}
